import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';

import Paragraph from '../../Paragraph/Paragraph';
import { variables } from '../../../assets/styles/variables';

const CountdownWrapper = styled.div`
  flex-direction: row;
  margin-top: ${pxToRem(8)};
  margin-bottom: ${pxToRem(8)};
`;

const CountdownTimerContainer = styled.div`
  align-items: center;
  border-radius: ${pxToRem(8)};
  padding: ${pxToRem(4)};
  display: flex;
  align-items: center;
`;

const CountdownCircleWrapper = styled.div`
  position: relative;
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

// const CountdownTimerText = styled(Paragraph)`
//   text-align: center;
//   font-size: ${pxToRem(24)};
//   margin-left: ${pxToRem(8)};
// `;

const CountdownText = styled(Paragraph)`
  font-size: ${pxToRem(14)};
  margin-left: ${pxToRem(6)};
`;

const CIRCLE_RADIUS = 14; // px
const CIRCLE_STROKE = 2; // px
const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

const PriceLockTimer = ({ counter, loading, label, labelColor }) => {
  const { t } = useTranslation();

  const displayValue = loading || counter === 1 ? 0 : counter - 2;

  const progress = Math.max(0, Math.min(1, displayValue / 30));
  const strokeDashoffset = CIRCLE_CIRCUMFERENCE * (1 - progress);

  return (
    <CountdownWrapper>
      <CountdownTimerContainer>
        <CountdownCircleWrapper>
          <svg width={32} height={32}>
            <circle
              cx={16}
              cy={16}
              r={CIRCLE_RADIUS}
              stroke={themeColors.colorGrey2}
              strokeWidth={CIRCLE_STROKE}
              fill="none"
            />

            <circle
              cx={16}
              cy={16}
              r={CIRCLE_RADIUS}
              stroke={themeColors.colorSuccess}
              strokeWidth={CIRCLE_STROKE}
              fill="none"
              strokeDasharray={CIRCLE_CIRCUMFERENCE}
              strokeDashoffset={strokeDashoffset}
              style={{
                transition: 'stroke-dashoffset 1s linear',
                transform: 'rotate(90deg)',
                transformOrigin: '50% 50%',
              }}
            />
            <text
              x="16"
              y="21"
              textAnchor="middle"
              fontSize="14"
              fill={themeColors.colorTextSecondary}
              fontWeight="400"
              fontFamily={variables.family.goldSilver}
            >
              {displayValue}
            </text>
          </svg>
        </CountdownCircleWrapper>
        {/* <CountdownTimerText variant="primary">
          {loading || counter === 1 ? 0 : counter - 2}
        </CountdownTimerText> */}
        <CountdownText color={labelColor}>
          {label ?? t('buyWizard.priceLockedFor')}
        </CountdownText>
      </CountdownTimerContainer>
    </CountdownWrapper>
  );
};

PriceLockTimer.propTypes = {
  counter: PropTypes.number,
  loading: PropTypes.bool,
  label: PropTypes.string,
  labelColor: PropTypes.string,
};

export default PriceLockTimer;
